import "./styles.css";
import articles from "./articles.json";
import readXlsxFile from "read-excel-file";
let input = document.getElementById("input");

// console.log(articles.articles);

let fresh = 0,
  foodDry = 0,
  beverages = 0,
  tmc = 0,
  hotDrinks = 0,
  sandwiches = 0,
  backShopAndOthers = 0;

input.addEventListener("change", function () {
  readXlsxFile(input.files[0]).then(function (result) {
    result.forEach((row) => {
      for (const property in articles.articles) {
        if (
          row[1] === articles.articles[property].sku &&
          articles.articles[property].group.substring(0, 3) === "910"
        ) {
          fresh += row[48];
        } else if (
          row[1] === articles.articles[property].sku &&
          articles.articles[property].group.substring(0, 3) === "915"
        ) {
          foodDry += row[48];
        } else if (
          row[1] === articles.articles[property].sku &&
          articles.articles[property].group.substring(0, 3) === "920"
        ) {
          beverages += row[48];
        } else if (
          row[1] === articles.articles[property].sku &&
          articles.articles[property].group.substring(0, 3) === "940"
        ) {
          if (
            articles.articles[property].group.substring(0, 5) === "94010" ||
            articles.articles[property].group.substring(0, 5) === "94011" ||
            articles.articles[property].group.substring(0, 5) === "94012" ||
            articles.articles[property].group.substring(0, 5) === "94034"
          ) {
            tmc += row[48];
          }
        } else if (
          row[1] === articles.articles[property].sku &&
          articles.articles[property].group.substring(0, 3) === "950"
        ) {
          if (articles.articles[property].group.substring(0, 5) === "95011") {
            hotDrinks += row[48];
          } else if (
            articles.articles[property].group.substring(0, 5) === "95014"
          ) {
            sandwiches += row[48];
          } else if (
            articles.articles[property].group.substring(0, 5) === "95010" ||
            articles.articles[property].group.substring(0, 5) === "95012" ||
            articles.articles[property].group.substring(0, 5) === "95013" ||
            articles.articles[property].group.substring(0, 5) === "95015" ||
            articles.articles[property].group.substring(0, 5) === "95016" ||
            articles.articles[property].group.substring(0, 5) === "95017"
          ) {
            backShopAndOthers += row[48];
          }
        }
      }
    });

    document.querySelector(".fresh").innerText = ` ${fresh.toFixed(2)} лв.`;
    document.querySelector(".food-dry").innerText = ` ${foodDry.toFixed(
      2
    )} лв.`;
    document.querySelector(".beverages").innerText = ` ${beverages.toFixed(
      2
    )} лв.`;
    document.querySelector(".tmc").innerText = ` ${tmc.toFixed(2)} лв.`;
    document.querySelector(".hot-drinks").innerText = ` ${hotDrinks.toFixed(
      2
    )} лв.`;
    document.querySelector(".sandwiches").innerText = ` ${sandwiches.toFixed(
      2
    )} лв.`;
    document.querySelector(
      ".back-shop"
    ).innerText = ` ${backShopAndOthers.toFixed(2)} лв.`;
  });
});
